var map = {
	"./blog1.json": [
		775,
		775
	],
	"./blog2.json": [
		958,
		958
	],
	"./blog3.json": [
		145,
		145
	],
	"./blogs.json": [
		985
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 720;
module.exports = webpackAsyncContext;